import React from 'react';

import {FIRST_PAGE, INFINITE_SCROLL_PAGE_LIMIT, NEXT_DIRECTION} from 'brand/app/constants';
import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import LoadMoreButton from 'brandComponents/LoadMoreButton';
import ScrollMore from 'brandComponents/ScrollMore';

import {IPaginationProps} from './IPagination';

const Pagination = ({
	pageToLoad,
	totalItems,
	totalItemsLoaded,
	direction,
	searchType,
	searchInstanceKey,
}: IPaginationProps) => {
	const {isPrevPageLoaded} = useCategoryContext(true) || {};

	if (direction === NEXT_DIRECTION) {
		if (totalItems !== totalItemsLoaded) {
			if (pageToLoad > INFINITE_SCROLL_PAGE_LIMIT) {
				return (
					<LoadMoreButton
						direction={direction}
						searchInstanceKey={searchInstanceKey}
						searchType={searchType}
					/>
				);
			} else {
				return (
					<ScrollMore
						direction={direction}
						searchInstanceKey={searchInstanceKey}
						searchType={searchType}
					/>
				);
			}
		}
	} else if (pageToLoad >= FIRST_PAGE && isPrevPageLoaded) {
		return (
			<ScrollMore
				direction={direction}
				searchInstanceKey={searchInstanceKey}
				searchType={searchType}
			/>
		);
	}

	return <></>;
};

export default Pagination;
